import React, { useState, useEffect } from 'react';
import DaumPostcode from 'react-daum-postcode';
import Modal from 'react-modal';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import CustomModal from './CustomModal';
import UtilController from '../../controller/UtilController';
import { CurrentStoreContext } from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import { useToast } from '../../controller/ToastController';
import {
  Option,
  Order,
  OrderChild,
  SetMenuGroup,
  SetMenu,
  Coupon,
} from '../../controller/OrderController';
import 'moment/locale/ko';
import moment from 'moment';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  orderId?: string;
  orderDetail?: OrderChild;
};

const PeriodDetailModal = ({ isVisible, setVisible, orderId, orderDetail }: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };
  useEffect(() => {}, [orderDetail]);

  const knockCouponData = orderDetail?.coupons?.filter((item) => item.com_discount_amount > 0);
  const storeCouponData = orderDetail?.coupons?.filter((item) => item.store_discount_amount > 0);

  console.log('knockCouponData-=----??', knockCouponData);
  console.log('storeCouponData-=----??', storeCouponData);
  console.log('orderDetail?.coupons-=----??', orderDetail?.coupons);
  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="settlementModal modal-content bottom"
      closeTimeoutMS={100}
      shouldCloseOnEsc={true}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
            alt="close"
          />
          <div className="content dashed">
            <h3 className="orderTime">
              {moment(orderDetail?.ordered_at).format('YYYY/MM/DD HH:mm:ss')}
            </h3>
            <div className="row orderId">
              <h2>[주문번호]</h2>
              <h2>{orderId}</h2>
            </div>
            <div className="title">
              <h2>{orderDetail?.delivery_address}</h2>
            </div>
            <div className="title">
              <h2>{orderDetail?.store_name}</h2>
            </div>
          </div>
          <div className="content dashed">
            <div className="row between">
              <h1 className="productName">상품명</h1>
              <h1 className="productCount">수량</h1>
              <h1 className="productPrice">금액</h1>
            </div>
          </div>
          <div>
            {orderDetail?.detail?.map((menu) => (
              <div className="content solid" key={menu.product_id}>
                <div className="row between">
                  <h2 className="productName">{menu.product_name}</h2>
                  <h2 className="productCount">{menu.product_quantity}개</h2>
                  <h2 className="productPrice">
                    {(menu.product_org_price * menu.product_quantity).toLocaleString()}원
                  </h2>
                </div>
                {menu.product_discount > 0 && (
                  <div className="row between">
                    <h3>상품 할인</h3>
                    <h3>- {(menu.product_discount * menu.product_quantity).toLocaleString()}원</h3>
                  </div>
                )}
                {menu.options.length > 0 && (
                  <div className="optionWrap">
                    {menu.options?.map((option: Option) => (
                      <div key={option.option_id} className="row">
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_arrow_option.svg`}
                          alt="optionIcon"
                        />
                        <h3 className="optionName">[옵션]{option.option_name}</h3>
                        <h3>{(option.option_price * menu.product_quantity).toLocaleString()}원</h3>
                      </div>
                    ))}
                  </div>
                )}
                {/* 세트메뉴 */}
                {menu.set_prd_type_list.length > 0 && (
                  <div className="setMenuWrap">
                    {menu.set_prd_type_list?.map((setMenuGroup: SetMenuGroup) => (
                      <div key={setMenuGroup.set_prd_type_id}>
                        <h2 className="setMenuTitle">
                          {setMenuGroup.set_prd_type_min > 0 ? '구성' : '선택'}
                          <span>&#41;</span> {setMenuGroup.set_prd_type_name}
                        </h2>
                        <div className="optionWrap">
                          {setMenuGroup?.set_product?.map((setMenu: SetMenu) => (
                            <>
                              <div key={setMenu.product_id} className="row">
                                <img
                                  src={`${process.env.PUBLIC_URL}/svg/ic_arrow_option.svg`}
                                  alt="optionIcon"
                                />
                                <h3 className="optionName">[옵션]{setMenu.product_name}</h3>
                                <h3>
                                  {(setMenu.product_price * menu.product_quantity).toLocaleString()}
                                  원
                                </h3>
                              </div>
                              {setMenu?.options?.map((option: Option) => (
                                <div key={option.option_id} className="row setMemuOption">
                                  <img
                                    src={`${process.env.PUBLIC_URL}/svg/ic_arrow_option.svg`}
                                    alt="optionIcon"
                                  />
                                  <h3 className="optionName">
                                    [{option.option_type_name}] {option.option_name}
                                  </h3>
                                  <h3>
                                    {(option.option_price * menu.product_quantity).toLocaleString()}
                                    원
                                  </h3>
                                </div>
                              ))}
                            </>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="content dashed">
            <div className="row between">
              <h1>할인금액</h1>
              <h1>{orderDetail?.discount_amount.toLocaleString()}원</h1>
            </div>
            {orderDetail !== undefined &&
              orderDetail.com_discount_amount !== undefined &&
              orderDetail?.com_discount_amount > 0 && (
                <div>
                  <div className="row between discount">
                    <h2>노크노크 부담</h2>
                    <h2>{orderDetail?.com_discount_amount?.toLocaleString()}원</h2>
                  </div>
                  {knockCouponData?.map((coupon: Coupon) => (
                    <div className="couponWrap">
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_arrow_option.svg`}
                        alt="optionIcon"
                      />
                      <p className="couponName">{coupon.coupon_name}</p>
                      <p className="couponPrice">{coupon.com_discount_amount}원</p>
                    </div>
                  ))}
                </div>
              )}
            {orderDetail !== undefined &&
              orderDetail.store_discount_amount !== undefined &&
              orderDetail?.store_discount_amount > 0 && (
                <div>
                  <div className="row between discount">
                    <h2>사장님 부담</h2>
                    <h2>{orderDetail?.store_discount_amount?.toLocaleString()}원</h2>
                  </div>

                  {storeCouponData?.map((coupon: Coupon) => (
                    <div className="couponWrap">
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_arrow_option.svg`}
                        alt="optionIcon"
                      />
                      <p className="couponName">{coupon.coupon_name}</p>
                      <p className="couponPrice">{coupon.store_discount_amount}원</p>
                    </div>
                  ))}
                </div>
              )}
          </div>
          <div className="content dashed">
            <div className="row between">
              <h2>배달팁</h2>
              <h2>{orderDetail?.delivery_tip?.toLocaleString()}원</h2>
            </div>
          </div>
          {orderDetail?.total_amount_incl!==undefined && orderDetail.room_tip!== undefined && 
          <div className="content dashed total">
            <div className="row">
              <h1 className="productName">합계 금액</h1>
              <h1 className="productCount">{orderDetail.detail.length}개</h1>
              <h1 className="productPrice">{(orderDetail.total_amount_incl-orderDetail.room_tip).toLocaleString()}원</h1>
            </div>
          </div>
          } 
          <button className="closeButton" onClick={onCloseModal}>
            확인
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default PeriodDetailModal;

const Style = styled.div`
  .modal {
    max-height: 80vh;
    padding: 41px 8%;
  }
  h1,
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  h1 {
    font-weight: 600;
  }
  h3 {
    font-size: 16px;
    font-weight: 400;
    color: #555;
  }
  .title {
    margin-top: 11px;
    h2 {
      text-align: left;
      line-height: 25px;
    }
  }
  .orderTime {
    margin-bottom: 11px;
    text-align: left;
    color: #a7a7a7;
  }
  .orderId {
    padding: 0;
  }

  /* content */
  .content.dashed {
    padding: 16px 0;
    border-bottom: 1px dashed #cecece;
  }
  .content.solid {
    padding: 20px 0;
    border-bottom: 1px solid #cecece;
  }
  .content.dashed:nth-child(1) {
    padding-top: 0;
  }

  .productName {
    flex: 0 0 55%;
    width: 55%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }
  .productCount {
    flex: 0 0 15%;
  }
  .productPrice {
    flex: 0 0 30%;
    text-align: right;
  }

  /* setMenuWrap */
  .setMenuWrap {
    width: 100%;

    .setMenuTitle {
      margin-top: 8px;
      text-align: left;
      font-size: 16px;
    }
    .optionWrap {
      margin: 0;
    }
  }

  /* optionWrap */
  .optionWrap {
    margin-top: 4px;

    img {
      margin-right: 9px;
    }
    h3:nth-last-child(1) {
      margin-left: auto;
    }
    .optionName {
      flex: 0 0 65%;
      width: 65%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
    }
  }

  /* setMemuOption */
  .setMemuOption {
    margin-left: 20px;

    h3 {
      font-size: 14px;
      line-height: 22px;
    }
  }

  /* discount */
  .discount {
    margin-top: 9px;

    h2 {
      font-size: 16px;
    }
  }

  /* couponWrap */
  .couponWrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    text-align: left;
    gap: 8px;

    p {
      font-size: 14px;
      font-weight: 400;
      color: #555;
      margin-top: 2px;
    }
    .couponName {
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .couponPrice {
      width: 30%;
      text-align: right;
    }
  }

  /* closeButton */
  button {
    width: 100%;

    margin: 50px 0 20px 0;
    padding: 12px 0;
    font-size: 20px;
    font-weight: 600;
    background: #4dd2ae;
    color: #fff;
    border-radius: 10px;
  }

  @media (max-width: 900px) {
    .modal {
      padding: 4%;
    }
    .modal_footer {
      padding-bottom: 8%;
    }
  }
`;
